import { navigate } from 'gatsby'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { isPreSale } from 'src/utils/pdp/isPreSale'

import type { ProductItem } from '../../types/productItem'
import type { AddToCartFn } from './useAddToCartLogic'

// Helper para enviar evento de Quick View do produto
const sendProductQuickViewEvent = (
  standardObject: Record<string, unknown>,
  productObject: Record<string, unknown>
) => {
  dispatchAmplitudeEvent({
    eventName: 'Click Product Quick View',
    eventData: {
      ...standardObject,
      ...productObject,
    },
  })
}

export function useBuyButtonHandler(params: {
  currentSku: ProductItem
  hasMultipleItems: boolean
  currentProductIsGiftCard: boolean
  cartContainsGiftCard: boolean
  cartContainsPreSaleItem: boolean
  standardObject: Record<string, unknown> | null
  productObject: Record<string, unknown> | null
  openSkuSelectionModal: () => void
  addToCartFn: AddToCartFn
  setOpenModalGiftCard: (value: boolean) => void
  setOpenModalPreSale: (value: boolean) => void
  slug: string
}) {
  const {
    currentSku,
    hasMultipleItems,
    currentProductIsGiftCard,
    cartContainsGiftCard,
    cartContainsPreSaleItem,
    standardObject,
    productObject,
    openSkuSelectionModal,
    addToCartFn,
    setOpenModalGiftCard,
    setOpenModalPreSale,
    slug,
  } = params

  return (e: React.MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation()

    if (standardObject && productObject) {
      sendProductQuickViewEvent(standardObject, productObject)
    }

    if (currentProductIsGiftCard) {
      navigate('/cartao-presente/p')

      return null
    }

    if (cartContainsGiftCard && !currentProductIsGiftCard) {
      setOpenModalGiftCard(true)

      return null
    }

    const currentProductIsPreSale = isPreSale(currentSku.estimatedDateArrival)

    if (currentProductIsPreSale) {
      navigate(`/${slug}/p`)

      return null
    }

    if (cartContainsPreSaleItem && !currentProductIsPreSale) {
      setOpenModalPreSale(true)

      return null
    }

    if (hasMultipleItems) {
      openSkuSelectionModal()

      return null
    }

    return addToCartFn('addToCart', currentSku, e)
  }
}
